import Vue from "vue";
import VueRouter from "vue-router";
import { routeCadastros } from "./cadastros";
import { routeRelatorios } from "./relatorios";
import { routeContratos } from "./contratos";
import { routeAcoes } from "./acoes";
import { routeAdmin } from "./admin";

Vue.use(VueRouter);

let checkAuth = (to, from, next) => {
    if (!window.localStorage.getItem("user")) {
        return next({ path: "/login" });
    }
    let user = JSON.parse(window.localStorage.getItem("user"));

    if (user && user.contrato_id) {
        if (to.matched[0].path !== "/contrato") {
            console.log(to.matched[0].path, "/contrato");
            return next({ path: "/contrato/portas/" + user.contrato_id });
        } else if (to.params.id !== user.contrato_id) {
            return next({ path: "/contrato/portas/" + user.contrato_id });
        }
    }
    next();
};

const routes = [
    {
        path: "/login",
        component: () =>
            import(/* webpackChunkName: "login" */ "../pages/Login.vue")
    },
    {
        path: "/monitoramento",
        component: () =>
            import(/* webpackChunkName: "monitoramento" */ "../pages/Monitoramento.vue")
    },
    {
        path: "/senha/:token",
        component: () =>
            import(/* webpackChunkName: "senha" */ "../pages/Senha.vue")
    },
    {
        path: "/",
        component: () =>
            import(/* webpackChunkName: "principal" */ "../pages/Principal.vue"),
        beforeEnter: checkAuth
    },
    {
        path: "/onus-off",
        component: () =>
            import(/* webpackChunkName: "alerta_onu_off" */ "../pages/AlertaOnusOff"),
        beforeEnter: checkAuth
    },
    {
        path: "/integracao/:token",
        component: () =>
            import(/* webpackChunkName: "principal_token" */ "../pages/PrincipalTokenIntegracao.vue")
    }
];

routeCadastros(routes, checkAuth);
routeRelatorios(routes, checkAuth);
routeContratos(routes, checkAuth);
routeAcoes(routes, checkAuth);
routeAdmin(routes, checkAuth);

export let router = new VueRouter({
    routes // short for routes: routes
});

router.beforeEach((to, from, next) => next());
